export default "__VITE_PUBLIC_ASSET__8806cd78__"